import React, { useState } from "react";
import { Modal, notification } from "antd";
import SectionList from "./SectionsList";
import useResumeStudio from "../../../../hooks/useResumeStudio";
import { DEFAULT_TEMPLATE } from "./pdf/templates";
import LivePreview from "./preview/LivePreview";
import { useSearchParams } from "react-router-dom";
import Utils from "../../../../utils/Utils";
import WebUtils from "../../../../utils/WebUtils";
import { updateResumeDataApi } from "../../../../api/b2b-candidate";
import FinalizeSubmitModal from "./modals/FinalizeSubmitModal";
import ResumeDocument from "./pdf/ResumeDocument";
import { pdf } from "@react-pdf/renderer";
import SaveAnotherCopyModal from "./modals/SaveAnotherCopyModal";

const CVMain = ({ setLoading }) => {
  const [searchParams] = useSearchParams();
  const resumeIdentifier = searchParams.get("resumeIdentifier");
  const userDetail = Utils.getUserDetail();

  const studio = useResumeStudio(resumeIdentifier, setLoading);

  const [templateKey, setTemplateKey] = useState(DEFAULT_TEMPLATE);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [submitModal, setSubmitModal] = useState(false);
  const [saveCopyModal, setSaveCopyModal] = useState(false);

  const handleSaveAsDraft = () => {
    const url = `${updateResumeDataApi}?resumeIdentifier=${
      resumeIdentifier || null
    }&userIdentifier=${userDetail?.userIdentifier}`;
    setLoading(true);
    const body = studio?.buildSavePayload?.() ?? {
      resumeData: studio?.sectionData,
    };

    WebUtils.httpOperations(url, body, "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          notification.success({
            message: "Success",
            description: "Resume changes saved!",
          });
        } else {
          notification.error({
            message: "Error",
            description: "Resume changes save failed!",
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const generatePdfBlob = async () => {
    const liveDoc = (
      <ResumeDocument
        sections={studio?.sections}
        sectionData={studio?.sectionData}
        templateKey={templateKey}
        authorName={studio?.resumeMetaData?.resumeFileName}
      />
    );

    return pdf(liveDoc).toBlob();
  };

  return (
    <>
      {submitModal && (
        <FinalizeSubmitModal
          submitModal={submitModal}
          setSubmitModal={setSubmitModal}
          setLoading={setLoading}
          resumeMetaData={studio?.resumeMetaData}
          buildSavePayload={studio?.buildSavePayload}
          userDetail={userDetail}
          generatePdfBlob={generatePdfBlob}
        />
      )}
      {saveCopyModal && (
        <SaveAnotherCopyModal
          saveCopyModal={saveCopyModal}
          setSaveCopyModal={setSaveCopyModal}
          setLoading={setLoading}
          resumeMetaData={studio?.resumeMetaData}
          buildSavePayload={studio?.buildSavePayload}
          userDetail={userDetail}
          generatePdfBlob={generatePdfBlob}
        />
      )}
      <div className="py-2 grid grid-cols-1 lg:grid-cols-[60%_40%] gap-4">
        <div>
          <SectionList
            {...studio}
            setPreviewOpen={setPreviewOpen}
            handleSaveAsDraft={handleSaveAsDraft}
            setSubmitModal={setSubmitModal}
            setSaveCopyModal={setSaveCopyModal}
            resumeIdentifier={resumeIdentifier}
          />
        </div>
        <Modal
          open={previewOpen}
          onCancel={() => setPreviewOpen(false)}
          footer={null}
          width="1200px"
          centered
          destroyOnClose
          styles={{
            body: {
              padding: 0,
              height: "85vh",
            },
          }}
        >
          <LivePreview
            sections={studio.sections}
            sectionData={studio.sectionData}
            templateKey={templateKey}
            onTemplateChange={setTemplateKey}
            onClose={() => setPreviewOpen(false)}
          />
        </Modal>
        <div className="hidden lg:block">
          <LivePreview
            sections={studio.sections}
            sectionData={studio.sectionData}
            templateKey={templateKey}
            onTemplateChange={setTemplateKey}
            onClose={() => setPreviewOpen(false)}
            resumeMetaData={studio?.resumeMetaData}
            generatePdfBlob={generatePdfBlob}
          />
        </div>
      </div>
    </>
  );
};

export default CVMain;
